export class PrintQueueRequest{
    constructor(applicant : string){
        this.applicantName = applicant;
    }
    applicantName : string;
}